// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {checkZan, checkZanList, productImg, pintieImg, headimg, getBrowserInterfaceSize, productReladImg} from './utils/common'
import { Swipe, SwipeItem, Toast, Popup, Loading, Dialog } from 'vant'
import 'vant/lib/index.css'
// px2rem移动端适配
import 'lib-flexible'

// mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import VueLazyload from 'vue-lazyload'
// axios
import axios from 'axios'
import 'url-search-params-polyfill'
// cookies
import VueCookies from 'vue-cookies'
// 复制
import VueClipboard from 'vue-clipboard2'
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// FastClick点击延迟
import FastClick from 'fastclick'
// 视频插件
import VideoPlayer from 'vue-video-player'
import smwDict from './utils/smwdict'
// 瀑布流插件
import waterfall from 'vue-waterfall2'
// 神策
import sensors from './utils/sensors'

Vue.use(waterfall)

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.prototype.$sensors = sensors
Vue.prototype.smwDict = smwDict
// 列表点赞
Vue.prototype.zanFun = checkZan
Vue.prototype.zanListFun = checkZanList
Vue.prototype.productImgFun = productImg
Vue.prototype.pintieImgFun = pintieImg
Vue.prototype.productReladImg = productReladImg
Vue.prototype.headimgFun = headimg
Vue.prototype.getBrowserFun = getBrowserInterfaceSize

Vue.prototype.$axios = axios
Vue.prototype.$cookies = VueCookies
FastClick.attach(document.body)
// axios.defaults.baseURL = '/api' // 测试api，解决本地跨域问题
axios.defaults.baseURL = process.env.BASE_API
axios.defaults.headers.common['os'] = 'h5'
// axios.defaults.headers.common['ver'] = '3.5.4'
axios.defaults.headers.common['ver'] = '3.7.2'
Vue.prototype.baseApi = process.env.BASE_API
Vue.prototype.imgUrl = process.env.IMG_URL
Vue.prototype.newImgUrl = 'https://sami-1256315447.file.myqcloud.com'
Vue.prototype.toolImgUrl = 'https://samitool-1256315447.cos.ap-guangzhou.myqcloud.com/'
Vue.prototype.baseHome = process.env.BASE_HOME
Vue.prototype.marketId = '756'
Vue.prototype.easemobjs = 'https://webchat.7moor.com/javascripts/7moorInit.js'
Vue.prototype.mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/ // 手机验证正则表达式
// Vue.prototype.mobileReg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/ // 手机验证正则表达式
Vue.prototype.mobileEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/ // 邮箱验证正则表达式
Vue.prototype.idCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/ // 身份证15-18位正则表达式
Vue.prototype.idCardTai = /^[a-zA-Z][0-9]{9}$/ // 身份证15-18位正则表达式
Vue.prototype.usernameReg = /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/ // 验证真实姓名正则表达式
Vue.prototype.assNameReg = /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]{2,30}$/ // 满足中文，英文，数字，中划线，下划线的正则表达式
Vue.prototype.$defaultHeadimg = 'https://sami-1256315447.cos.ap-guangzhou.myqcloud.com/newImage/activity/202101/9820b239b0c3e3989a30de197e5c218.png'
Vue.prototype.$getUserInfo = () => {
  return new Promise(resolve => {
    axios.get('/v3/user').then(res => {
      if (!res.data.ret) {
        resolve(res.data.datas)
      } else {
        resolve('')
      }
    })
  })
}
Vue.prototype.stop = function () { // 禁止页面滑动
  document.body.style.overflow = 'hidden'
  document.documentElement.addEventListener('touchmove', function (e) {
    if (e.target.className === 'pop-bg') {
      e.preventDefault()
    }
  }, false)
}
Vue.prototype.$zanTest = (num) => {
  num = parseInt(num)
  if (num > 10000) {
    num = num / 10000 + ''
    if (num.indexOf('.') > 0) {
      num = parseFloat(num.slice(0, num.indexOf('.') + 2)) + '万+'
    }
  }
  return num
}
Vue.prototype.$operationAction = (operation) => {
  const params = new FormData()
  params.append('operation', operation)
  axios.post('/vip/operation', params)
}
Vue.prototype.$getRule = (id) => {
  return new Promise(resolve => {
    axios.get('user/samihelp', {
      params: {
        category: id
      }
    }).then(res => {
      if (res.data.ret === 0) {
        resolve(res.data.datas.rows[0].content.replace(/p/g, 'p'))
      }
    })
  })
}
Vue.prototype.$getRecommendProduct = (page, ranNumber) => {
  return new Promise(resolve => {
    axios.get('/product', {
      params: {
        page: page,
        perPage: 20,
        groupType: '0, 4',
        sortField: ranNumber
      }
    }).then(res => {
      resolve(res)
    })
  })
}
Vue.prototype.encodeBase64 = (key) => {
  return window.btoa(unescape(encodeURIComponent(key)))
}
Vue.prototype.$historys = []
Vue.prototype.$isBack = false
router.beforeEach((to, from, next) => {
  next()
  if (!Vue.prototype.$isBack) {
    Vue.prototype.$historys.push(to.fullPath)
  } else {
    Vue.prototype.$historys.pop()
  }
  setTimeout(() => {
    Vue.prototype.$isBack = false
  }, 500)
  console.log(Vue.prototype.$historys)
})
Vue.prototype.$commonBack = () => {
  Vue.prototype.$isBack = true
  if ((sessionStorage.getItem('miniUrl') || sessionStorage.getItem('webview')) && Vue.prototype.$historys.length <= 1 && location.href.indexOf('noCloseWebview') < 0) {
    if (sessionStorage.getItem('miniUrl')) {
      uni.redirectTo({
        url: sessionStorage.getItem('miniUrl') + '?closeWebview=1'
      })
    } else {
      location.href += '?closeWebview=1'
    }
  } else {
    history.go(-1)
  }
}
window.addEventListener('popstate', (e) => {
  Vue.prototype.$isBack = true
}, false)
const wxShareConfig = (share) => {
  axios.get('/user/wxsign', {
    params: {
      url: share.shareUrl
    }
  }).then(res => {
    const data = res.data.datas.weConfig
    wx.config({
      debug: false,
      appId: data.appid,
      timestamp: data.timestamp,
      nonceStr: data.noncestr,
      signature: data.signature,
      jsApiList: ['onMenuShareAppMessage']
    })
    wx.ready(() => {
      var shareConfig = {
        title: share.title,
        desc: share.desc,
        link: share.shareUrl,
        imgUrl: share.img
      }
      if (wx.onMenuShareAppMessage) {
        wx.onMenuShareAppMessage(shareConfig)
        wx.onMenuShareTimeline(shareConfig)
      } else {
        wx.updateAppMessageShareData(shareConfig)
        wx.updateTimelineShareData(shareConfig)
      }
    })
  })
}
Vue.prototype.$shareAction = (share, type, id) => {
  let shareUrl = share.shareUrl
  if (shareUrl.indexOf('pintuanDetail') > -1 || shareUrl.indexOf('inval2023') > -1 || shareUrl.indexOf('pintieDetail') > -1 || shareUrl.indexOf('newsDetail') > -1) {
    if (shareUrl.indexOf('inval2023') > -1) {
      newVue.getfanpai('?inviteType=1')
    } else {
      newVue.getfanpai('')
    }
  }
  if (sessionStorage.getItem('webview')) {
    let ua = navigator.userAgent
    let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isiOS) {
      try {
        window.webkit.messageHandlers.iosNativeShare.postMessage({body: shareUrl + '$' + share.title + '$' + share.desc + '$' + share.img})
      } catch (error) {
        console.log('WKWebView post message')
      }
    } else {
      jsToAndroid.shareParameter(shareUrl, share.title, share.desc, share.img)
    }
  } else if (!sessionStorage.getItem('miniUrl')) {
    const shareStr = share.title + ' ' + share.desc + ' ' + shareUrl
    Vue.prototype.$copyText(shareStr).then(e => {
      Vue.$toast('已将分享内容复制到粘贴板，快去分享给小伙伴吧！')
    }, e => {
      Vue.$toast('分享内容复制到粘贴板失败：' + e)
    })
    // if (shareUrl.indexOf('pintuanDetail') > -1 || shareUrl.indexOf('newyear2022') > -1) {
    //   newVue.getfanpai(1)
    // }
    // newVue.getFuka(1)
    Vue.prototype.$sensors.sensorsShare(shareUrl)
    // Vue.prototype.$sensors.sensorsShareResult(shareUrl, type, id.toString(), (share.title || share.desc))
  }
}
Vue.prototype.getBrowserInterfaceSize = function () {
  let pageWidth = window.innerWidth
  let pageHeight = window.innerHeight
  if (typeof pageWidth !== 'number') {
    // 在标准模式下面
    if (document.compatMode === 'CSS1Compat') {
      pageWidth = document.documentElement.clientWidth
      pageHeight = document.documentElement.clientHeight
    } else {
      pageWidth = document.body.clientWidth
      pageHeight = window.body.clientHeight
    }
  }
  return {
    pageWidth: pageWidth,
    pageHeight: pageHeight
  }
}
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  return fmt
}
Vue.prototype.getAbsTime = function () {
  // 获取绝对时间 即无论你在哪个时区，得到的时间和京8区的时间一致
  try {
    let currentZoneTime = new Date()
    let currentZoneHours = currentZoneTime.getHours()
    let offsetZone = currentZoneTime.getTimezoneOffset() / 60
    if (offsetZone > 0) {
      // 大于0的是西区（西区晚） 西区应该用时区绝对值加京八区 重新设置时间
      // 西区时间比东区时间晚 所以加时区间隔
      offsetZone = offsetZone + 8
      currentZoneTime.setHours(currentZoneHours + offsetZone)
    } else {
      // 小于0的是东区（东区早）  东区时间直接跟京八区相加
      offsetZone += 8
      currentZoneTime.setHours(currentZoneHours + offsetZone)
    }
    return currentZoneTime
  } catch (e) {
    throw e
  }
}

Vue.prototype.formatProductTime = function (list) {
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i]['endTimeShow'] !== '') {
      continue
    }
    const secondTime = parseInt(new Date(list[i]['endTime'].replace(/-/g, '/')).getTime() / 1000 - parseInt(this.getAbsTime().getTime() / 1000))
    if (secondTime <= 0) {
      list[i]['endTimeShow'] = 0
      return
    }
    if (secondTime > 86400) {
      list[i]['endTimeShow'] = Math.ceil((secondTime / 3600) / 24) + '天'
    } else {
      var timer = setInterval(() => {
        list[i]['endTimeShow'] = this.changeProductTime(parseInt(new Date(list[i]['endTime'].replace(/-/g, '/')).getTime() / 1000 - parseInt(this.getAbsTime().getTime() / 1000)))
      }, 1000)
    }
  }
}
Vue.prototype.formatProductStartTime = function (list) {
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i]['startTimeShow'] !== '') {
      continue
    }
    const secondTime = parseInt(parseInt(this.getAbsTime().getTime() / 1000) - new Date(list[i]['startTime'].replace(/-/g, '/')).getTime() / 1000)
    if (secondTime <= 0) {
      list[i]['startTimeShow'] = 0
      return
    }
    if (secondTime > 86400) {
      list[i]['startTimeShow'] = Math.ceil((secondTime / 3600) / 24) + '天'
    } else {
      var timer = setInterval(() => {
        list[i]['startTimeShow'] = this.changeProductTime(parseInt(this.getAbsTime().getTime() / 1000)) - parseInt(new Date(list[i]['startTime'].replace(/-/g, '/')).getTime() / 1000)
      }, 1000)
    }
  }
}
Vue.prototype.changeProductTime = function (time) {
  // 若起止时间已经小于0， 则说明结束（解决超过一小时后,显示NAN的bug）
  if (time <= 0) {
    return 0
  }
  time = time + 60
  let hour = parseInt(time / 3600)
  if (hour < 10) {
    hour = '0' + hour
  }
  let minute = parseInt((time - 3600 * hour) / 60)
  if (minute <= 0) {
    return 0
  }
  if (minute < 10) {
    minute = '0' + minute
  }
  let second = parseInt(((time - 3600 * hour) - 60 * minute) % 60)
  if (second < 10) {
    second = '0' + second
  }
  return hour + '时' + minute + '分'
}

Vue.prototype.move = function () { // 开启页面滑动
  document.body.style.overflow = ''
  document.removeEventListener('touchmove', function (e) {
    e.preventDefault()
  }, false)
}
// 客服
Vue.prototype.qimoChatConfig = function (chatImgUrl, chatUrl, chatText, isShow) {
  sessionStorage.setItem('kefuImgUrl', chatImgUrl)
  sessionStorage.setItem('kefuUrl', chatUrl)
  sessionStorage.setItem('kefuText', chatText)
  sessionStorage.setItem('kefuShow', isShow)
  this.$router.push({
    name: 'kefu'
  })
}
// request拦截器
axios.interceptors.request.use(
  config => {
    let cp = '3'
    // let ver = config.url.indexOf('/home/miquan') > -1 ? '&ver=3.7.0' : '&ver=3.5.4'
    let ver = config.url.indexOf('/home/miquan') > -1 ? '&ver=3.7.0' : '&ver=3.7.2'
    const dot = config.url.indexOf('?') > -1 ? '&' : '?'
    config.url = config.url + dot + 'cp=' + cp + ver
    if (sessionStorage.getItem('access-token')) {
      config.url = config.url + '&access-token=' + sessionStorage.getItem('access-token')
    }
    if (sessionStorage.getItem('miniUrl')) {
      config.url = config.url + '&miniUrl=' + sessionStorage.getItem('miniUrl')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })
// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (sessionStorage.getItem('access-token') && response.config.url.indexOf('/vip/operation') < 0 && !VueCookies.isKey('operationLogin')) {
      Vue.prototype.$operationAction('login')
      VueCookies.set('operationLogin', 1)
    }
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (router.currentRoute.fullPath !== '/' && router.currentRoute.fullPath.indexOf('login') < 0) {
            sessionStorage.setItem('entranceUrl', encodeURIComponent(router.currentRoute.fullPath))
          }
          // 返回 401 清除token信息并跳转到登录页面
          if (sessionStorage.getItem('miniUrl')) {
            uni.reLaunch({
              url: '../login/index'
            })
            return
          }
          VueCookies.remove('access-token')
          sessionStorage.removeItem('access-token')
          if (location.href.indexOf('webview') > -1 || sessionStorage.getItem('webview')) {
            location.href += location.href.indexOf('?') > -1 ? '&nativeLogin' : '?nativeLogin'
          } else {
            router.replace({
              path: '/login',
              query: {redirect: router.currentRoute.fullPath}
            })
          }
      }
    }
    return Promise.reject(error)
  })
Vue.use(Swipe)
Vue.use(Dialog)
Vue.use(SwipeItem)
Vue.use(Toast)
Vue.use(Popup)
Vue.config.productionTip = false
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '../static/loading-svg/lz-error-square.png',
  loading: '../static/loading-svg/loading-spinning-bubbles.svg',
  attempt: 1
})
Vue.use(MintUI)
Vue.use(VueClipboard)
Vue.use(VueAwesomeSwiper)
Vue.use(VideoPlayer)
/* eslint-disable no-new */
const newVue = new Vue({
  el: '#app',
  data () {
    return {
      pageHeight: Vue.prototype.getBrowserInterfaceSize().pageHeight,
      fukaPhoto: '',
      fukaPopupVisible: false
    }
  },
  router,
  render: h => h(App),
  axios,
  FastClick,
  VueCookies,
  components: { App },
  template: '<App/>',
  created: function () {
    this.redirect()
  },
  methods: {
    redirect () {
      router.beforeEach((to, from, next) => { // 导航守卫
        if (to.name === 'pintieDetail') {
          // 用于标记是正常通过某页面跳转拼贴详情（非分享链接进入）
          sessionStorage.setItem('isDiscoverSkip', true)
        }
        next()
      })
    },
    getFuka (getType) {
      const url = getType === 1 ? '/wufu/getcard' : '/wufu/just-get-card'
      axios.get(url, {
        params: {
          getType: getType
        }
      }).then(res => {
        if (!res.data.ret) {
          if (res.data.datas.wufuUserCardList.length) {
            this.fukaPhoto = Vue.prototype.newImgUrl + res.data.datas.wufuUserCardList[0].bigPhoto
            this.fukaPopupVisible = true
          }
        } else {
          this.$toast('请求异常：' + res.data.msg)
        }
      })
    },
    getfanpai (query) {
      axios.get('/newyear/share' + query).then(res => {
        if (res.data.ret === 0) {
          if (res.data.datas.rows.wufucard) {
            this.fukaPhoto = Vue.prototype.newImgUrl + res.data.datas.rows.wufucard.bigPhoto
            this.fukaPopupVisible = true
            console.log(this.fukaPopupVisible)
          }
        } else {
          this.$toast('请求异常：' + res.data.msg)
        }
      })
      // axios.get('/wufu/just-get-card', {
      //   params: {
      //     getType: getType
      //   }
      // }).then(res => {
      //   if (!res.data.ret) {
      //     if (res.data.datas.wufuUserCardList.length) {
      //       this.fukaPhoto = Vue.prototype.newImgUrl + res.data.datas.wufuUserCardList[0].bigPhoto
      //       this.fukaPopupVisible = true
      //     }
      //   } else {
      //     this.$toast('请求异常：' + res.data.msg)
      //   }
      // })
    }
  }
})
export default newVue



// WEBPACK FOOTER //
// ./src/main.js